import React from 'react';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import I18n from 'i18n-js';

interface Props {
  categoryTranslationKey: string;
  selectedCategory: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export default function HomepageCategoryTile(props: Props) {
  const isSelected = props.selectedCategory === props.categoryTranslationKey;
  const classes = classNames(
    'homepage-category-tile',
    `homepage-category-tile--${kebabCase(props.categoryTranslationKey)}`,
    { 'homepage-category-tile--selected': isSelected },
  );

  return (
    <div className={classes}>
      <button
        className="homepage-category-tile__button"
        onClick={props.onClick}
        type="button"
      >
        <span className="homepage-category-tile__thumbnail" />
        <div className="homepage-category-tile__label">
          {I18n.t(`commons.homepage.categorySearch.${props.categoryTranslationKey}`)}
        </div>
      </button>
    </div>
  );
}
